/**
 * Sesión y guardia de rutas.  (FR-037)
 *
 * "Sin credencial no se ve NADA": la guardia envuelve TODO menos el login. La
 * sesión se comprueba contra `/auth/me`; si no hay, al login.
 */
import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router'

import { api } from './lib/api'

export interface Sesion {
    email: string
    role: 'admin' | 'cliente'
    /** `null` = admin (ve todos los negocios). Una lista = los suyos. */
    accountIds: number[] | null
    /** Spec 057 · ve, no escribe. */
    soloLectura?: boolean
    /** Spec 060 · solo el admin sembrado (info@). */
    gestionaUsuarios?: boolean
    /** Spec 043. Sin el campo (sesión vieja), el root usa auto + Default. */
    apariencia?: { tema: 'auto' | 'dark' | 'light'; plantilla: string }
}

export const CLAVE_SESION = ['sesion'] as const

export function useSoloLectura(): boolean {
    const { data } = useSesion()
    return data?.soloLectura === true
}

/** Consulta la sesión actual. `retry: false`: un 401 es respuesta, no fallo. */
export function useSesion() {
    return useQuery({
        queryKey: CLAVE_SESION,
        queryFn: () => api.get<Sesion>('/auth/me'),
        retry: false,
        staleTime: Infinity,
    })
}

function Cargando({ children }: { children: ReactNode }) {
    return (
        <div className="grid min-h-screen place-items-center bg-neutral-950 font-mono text-sm text-neutral-500">
            {children}
        </div>
    )
}

/** Deja pasar solo con sesión. Sin ella, redirige al login recordando de dónde venías. */
export function RequireAuth() {
    const { data, isPending, isError } = useSesion()
    const loc = useLocation()

    if (isPending) return <Cargando>Comprobando sesión…</Cargando>
    if (isError || !data) return <Navigate to="/login" replace state={{ from: loc.pathname }} />
    return <Outlet />
}
